import React from "react";
import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import { Button } from "@/components/ui/button";

const EFFECTIVE_DATE = "September 1, 2026";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#FAFBFD]">
      <Nav />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-14">
        <Link to="/" className="text-sm text-slate-500 hover:text-slate-900" data-testid="terms-back-link">← Back to home</Link>
        <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 tracking-tight mt-4">Terms of Service</h1>
        <p className="text-sm text-slate-500 mt-2">Effective: {EFFECTIVE_DATE}</p>

        <div className="prose prose-slate max-w-none mt-8 space-y-6 text-slate-700 text-[15px] leading-relaxed">

          <section>
            <h2 className="text-xl font-semibold text-slate-900">1. What Powerhouse Refunds Is</h2>
            <p>Powerhouse Refunds ("we", "us", or "the Service") is a self-service template and guidance tool that helps consumers request refunds for subscription charges applied after cancellation. We generate templated messages you can copy, paste, and send yourself. <strong>We are not a law firm. We do not provide legal advice. We do not represent you. We do not submit anything on your behalf.</strong></p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900">2. No Guarantee of Outcome</h2>
            <p>Refund outcomes depend on the merchant, your specific facts, and factors outside our control. <strong>We do not guarantee that you will receive any refund.</strong> Our $19 per-case fee is for the drafting and guidance service itself, not for a refund result.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900">3. Fees, Non-Refundable</h2>
            <p>Each case costs $19 USD, charged one time via Stripe. Second-attempt cases are $9. <strong>All fees are non-refundable</strong>, including if your merchant refuses to issue a refund, ignores your messages, or the case fails for any reason. By paying, you agree the fee is earned when the messages are unlocked.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900">4. Founder Program</h2>
            <p>The first 100 registered users receive one free case ("Founder Free Case"). This benefit is one-time, non-transferable, and applies only to the user's first case. Additional cases are charged at the standard rate.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900">5. Referral Credits</h2>
            <p>You may earn a $10 credit when a person you refer completes their first paid case. Credits apply as a discount on future cases and have no cash value. We may modify or discontinue the referral program at any time.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900">6. Your Responsibilities</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>You provide truthful information about your subscription and charge.</li>
              <li>You review each generated message before sending it.</li>
              <li>You send the messages yourself through your own email or the merchant's support channel.</li>
              <li>You will not use the Service to make false or fraudulent claims.</li>
              <li>You are at least 18 years old and live in the United States.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900">7. Prohibited Uses</h2>
            <p>You may not use the Service to harass merchants, submit knowingly false disputes, or attempt to chargeback legitimate charges. Violations may result in account termination without refund.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900">8. Third-Party Services</h2>
            <p>Payments are processed by Stripe. AI drafting uses Anthropic (Claude). Screenshots you upload are stored on Emergent Object Storage. Your use of these services through us is also subject to their respective terms.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900">9. Limitation of Liability</h2>
            <p>To the maximum extent permitted by law, our total liability to you for any claim relating to the Service is limited to the amount you paid us in the 6 months before the claim arose. We are not liable for indirect, incidental, or consequential damages, including denied refunds, chargeback failures, or lost time.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900">10. Termination</h2>
            <p>We may suspend or terminate your account at any time for violations of these Terms, suspected fraud, or misuse. You may close your account at any time by contacting support.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900">11. Changes to These Terms</h2>
            <p>We may update these Terms from time to time. Continued use after changes constitutes acceptance. Material changes will be notified via email or an on-site banner.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900">12. Governing Law</h2>
            <p>These Terms are governed by the laws of the State of Delaware, USA, without regard to conflict-of-law principles. Any disputes will be resolved in the state or federal courts located in Delaware.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900">13. Contact</h2>
            <p>Questions? Email <a href="mailto:support@powerhouserefunds.com" className="text-[#1E3A8A] hover:underline">support@powerhouserefunds.com</a>.</p>
          </section>

        </div>

        <div className="mt-10 text-center">
          <Link to="/"><Button variant="outline" className="rounded-full">Back to home</Button></Link>
        </div>
      </div>
    </div>
  );
}
